import withThreadsHoc from "../../helpers/withThreadsHoc";
import AffectivePoint from "./AffectivePoint";

const BooleanPointWithThreads = withThreadsHoc(AffectivePoint);

export default BooleanPointWithThreads;
